import { useMutation } from "@tanstack/react-query";
import { uploadDocument } from "./documents";
import { DocumentType } from "../constants/document-types";

export interface UploadDocumentProps {
  bookingNumber: number,
  document: File,
  documentType: DocumentType,
  shipmentId: string
}

export function useUploadDocument(){
  return useMutation({
    mutationFn: ({bookingNumber, document, documentType, shipmentId}: UploadDocumentProps) =>
      uploadDocument(bookingNumber, document, documentType, shipmentId),
  })
}
